import React from 'react';

export const MessageOverlay = (props: any) => (
  <div
    className="ag-overlay-loading-center"
    style={{ backgroundColor: '#9edbf7', height: '10%' }}
  >
    <span>{props.loadingMessage}</span>
  </div>
);

export default MessageOverlay;
